import { Toaster as SonnerToaster } from 'sonner';
import { useTheme } from '@/lib/theme';

export function Toaster(): JSX.Element {
  const { resolvedTheme } = useTheme();

  return (
    <SonnerToaster
      theme={resolvedTheme}
      position="bottom-right"
      // Hält den Toast oberhalb des iOS-Home-Balkens.
      offset="max(1rem, env(safe-area-inset-bottom))"
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'group border border-border bg-background text-foreground shadow-lg rounded-md text-sm',
          description: 'whitespace-pre-line break-words text-muted-foreground',
          actionButton: 'bg-primary text-primary-foreground',
          cancelButton: 'bg-muted text-muted-foreground',
        },
      }}
    />
  );
}
